/**
 * SIGSAOP brand logo. Renders inline SVG using `currentColor` so it adapts
 * to the parent text color (white on dark sidebar, slate-900 elsewhere).
 *
 * Concept:
 *  - 3 cordillera peaks → territorio y operaciones
 *  - Disco sol/comunidad sobre la cordillera
 *  - Base curva → tierra y agua
 */
export default function Logo({ size = 56, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="SIGSAOP"
    >
      {/* Outer rounded square */}
      <rect
        x="2"
        y="2"
        width="60"
        height="60"
        rx="14"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        opacity="0.85"
      />
      {/* Sun / community */}
      <circle cx="32" cy="20" r="4" fill="currentColor" />
      {/* Mountain peaks */}
      <path
        d="M9 50 L22 28 L31 40 L42 22 L55 50 Z"
        fill="currentColor"
        fillOpacity="0.18"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {/* Inner detail line on tallest peak */}
      <path
        d="M42 22 L46 32"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity="0.55"
      />
      {/* Baseline / land */}
      <path
        d="M9 54 Q32 49 55 54"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
        opacity="0.6"
      />
    </svg>
  );
}
